<div class="wrapper" [dir]="options.direction">
    <!-- data-image="assets/img/sidebar-bg/01.jpg" -->
    <div class="app-sidebar" data-active-color="white" data-background-color="purple-love" >
        <app-sidebar></app-sidebar>
        <div class="sidebar-background"></div>
    </div>
    <app-navbar></app-navbar>
    <div class="main-panel">
        <div class="main-content">
            <div class="content-wrapper">
                <div class="container-fluid">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
    <app-notification-sidebar></app-notification-sidebar>
    <!-- <app-customizer (directionEvent)="getOptions($event)"></app-customizer> -->
</div>